<template>
  <HawkFeaturedIcon theme="light-circle-outline" color="primary" size="md">
    <IconHawkInfoCircle />
  </HawkFeaturedIcon>
</template>
